var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"v-login"},[_c('c-login-header'),_c('c-login-carousel'),_c('c-login-form-wrapper'),(!_vm.isCookiePolicyAccepted)?_c('c-login-footer-cookie'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }